import Vue from 'vue'
import App from './App.vue'
import router from './router/'
import store from './store/'
import moment from 'moment'
import { extendMoment } from 'moment-range'
import i18n from './lang/lang'
import './plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.config.productionTip = false
Vue.prototype.moment = extendMoment(moment)

window.vm = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  computed: {
    showSpinner: {
      get() {
        return this.$store.state.showSpinner
      },
      set(val) {
        this.$store.commit('showSpinner', val)
      },
    },
    showSnackbar: {
      get() {
        return this.$store.state.showSnackbar
      },
      set(val) {
        this.$store.commit('showSnackbar', val)
      },
    },
  },
  render: (h) => h(App),
})
